export default __webpack_public_path__ + "static/media/red-like.d12d517b.svg";